import React from 'react'
import { LinearProgress } from '@mui/material'
import { GridOverlay } from '@mui/x-data-grid'
import './style.scss'

export const DataGridLoadingOverlay = () => (
  <GridOverlay>
    <div className="DataGridLoadingOverlay">
      <LinearProgress />
    </div>
  </GridOverlay>
)
